"use client";

import React from "react";
import { ArrowRight, FileBadge, Tag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BeginYourAcquisition() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="begin-your-acquisition" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-secondary/30 via-background to-background z-0 pointer-events-none" />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-[0.03] pointer-events-none z-0 flex items-center justify-center">
        <FileBadge className="w-[40rem] h-[40rem] text-primary" strokeWidth={0.5} />
      </div>

      <div ref={ref} className={`relative z-10 container mx-auto px-4 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 text-foreground font-sans max-w-4xl">
          Your Next Brand Identity is Ready.
        </h2>
        
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mb-12 font-sans">
          Acquire curated, legally-vetted trademarks and launch your brand in days, not months.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto justify-center items-center">
          <Button asChild size="lg" className="w-full sm:w-auto text-base h-14 px-8 rounded-full shadow-lg shadow-primary/20 transition-transform hover:scale-105">
            <Link to="/OurCataloguePage">
              Explore Available Brands
              <ArrowRight className="ml-2 w-5 h-5" />
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base h-14 px-8 rounded-full border-primary/30 hover:bg-primary/10 hover:text-primary transition-transform hover:scale-105 bg-background/50 backdrop-blur-sm">
            <Link to="/ContactPage">
              <Tag className="mr-2 w-5 h-5" />
              List Your Trademark
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}